import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const LegalShell = ({ title, updated, testId, children }) => (
  <main className="max-w-3xl mx-auto px-4 py-10" data-testid={testId}>
    <Link to="/" data-testid="legal-back-home" className="inline-flex min-h-11 items-center gap-2 text-sm text-muted-foreground mb-4"><ArrowLeft className="h-4 w-4" /> Volver a la tienda</Link>
    <h1 className="font-heading font-bold text-3xl text-foreground" data-testid="legal-title">{title}</h1>
    <p className="text-xs text-muted-foreground mt-2 mb-8">Última actualización: {updated}</p>
    <div className="space-y-6 text-sm leading-relaxed text-foreground [&_h2]:font-body [&_h2]:font-bold [&_h2]:text-lg [&_h2]:text-foreground [&_h2]:mt-6 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_p]:text-muted-foreground [&_li]:text-muted-foreground">
      {children}
    </div>
  </main>
);
export default LegalShell;
